import React from "react";
import { Link } from "react-router-dom";
function ServiceFIve() {
  return (
    <div className="service-three mt-5">
      <div className="service-area tmp-section-gapBottom">
        <div className="container">
          <div className="row g-5">
            <div
              className="col-lg-4 col-md-6 col-sm-6 col-12 wow fadeInUp"
              data-wow-duration=".8s"
              data-wow-delay=".1s"
            >
              <div className="service-inner financial-service-inner agency-service">
                <div className="icon">
                  <img
                    src="assets/images/services/tax-support.gif"
                    alt="corporate_Business_Services_agency"
                  />
                </div>
                <div className="content">
                  <h2 className="title">
                    Expert Tax Support
                  </h2>
                  <p className="description">
                    Trusted, certified experts ready to assist with your taxes professionals you can count on.
                  </p>
                  <div className="three--dot">
                    <a
                      className="tmp-btn btn-primary button-custom mb-5 d-block m-auto"
                      style={{ width: "60%", padding: "8px" }}
                      href="/tax"
                    >
                      Explore Tax Support
                    </a>
                  </div>
                </div>
                <Link to={"/tax"} className="over_link"></Link>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 col-sm-6 col-12 wow fadeInUp"
              data-wow-duration=".8s"
              data-wow-delay=".3s"
            >
              <div className="service-inner financial-service-inner agency-service">
                <div className="icon">
                  <img
                    src="assets/images/services/stress-free-tax.gif"
                    alt="corporate_Business_Services_agency"
                  />
                </div>
                <div className="content">
                  <h2 className="title">
                    Making Business Taxes Stress-Free
                  </h2>
                  <p className="description">
                    Enjoy accurate business tax filing backed by on-demand
                    expert guidance easy, reliable, and precise.
                  </p>
                  <div className="three--dot">
                    <div className="three--dot">
                      <a
                        className="tmp-btn btn-primary button-custom mb-5 d-block m-auto"
                        style={{ width: "60%", padding: "8px" }}
                        href="/contact-us"
                      >
                        Work With ANBS
                      </a>
                    </div>
                  </div>
                </div>
                <Link to={"/contact-us"} className="over_link"></Link>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 col-sm-6 col-12 wow fadeInUp"
              data-wow-duration=".8s"
              data-wow-delay=".5s"
            >
              <div className="service-inner financial-service-inner agency-service">
                <div className="icon">
                  <img
                    src="assets/images/services/grow-confidence.gif"
                    alt="corporate_Business_Services_Agency"
                  />
                </div>
                <div className="content">
                  <h2 className="title">
                    Grow with Confidence
                  </h2>
                  <p className="description">
                  From formation to payroll and taxes, we simplify finances so you can focus on growth.
                  </p>
                  <div className="three--dot">
                    <a
                      className="tmp-btn btn-primary button-custom mb-5 d-block m-auto"
                      style={{ width: "60%", padding: "8px" }}
                      href="/Service"
                    >
                      {" "}
                      Get Started{" "}
                    </a>
                  </div>
                </div>
                <Link to={"/Service"} className="over_link"></Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServiceFIve;
